interface FAQItem {
  question: string;
  answer: string;
}

const faqs: FAQItem[] = [
  {
    question: '夜猫影院需要付费吗？',
    answer: '完全免费！夜猫影院所有电视剧全集和热播剧完整版均免费提供高清在线观看，无需付费，无需会员，打开即看。我们通过赞助广告维持运营，承诺绝不向用户收费。',
  },
  {
    question: '观看需要注册账号吗？',
    answer: '不需要。夜猫影院支持免登录观看，打开网站即可直接追剧。如果你希望收藏剧集、记录播放进度或参与社区讨论，可以自愿注册账号享受更多个性化功能。',
  },
  {
    question: '视频画质如何？播放会卡顿吗？',
    answer: '我们提供最高1080P高清画质，并配备多条CDN加速线路，确保播放流畅不缓冲。如果遇到卡顿，可以尝试切换播放线路或稍等片刻，通常在晚间高峰时段我们会自动调度最优节点。',
  },
  {
    question: '更新速度怎么样？能和其他平台同步吗？',
    answer: '夜猫影院拥有专业的内容更新团队，国产热播剧通常在电视台播出后2小时内上线更新。海外剧集（韩剧、美剧、日剧等）在字幕组完成后第一时间同步，让你追剧不落人后。',
  },
  {
    question: '支持哪些设备观看？',
    answer: '夜猫影院支持全平台观看：电脑浏览器、手机浏览器、平板均可访问。我们还提供iOS和Android专属APP，适配夜间模式，支持离线缓存功能，躺在床上也能畅享追剧乐趣。',
  },
  {
    question: '遇到无法播放的问题怎么办？',
    answer: '如果遇到播放异常，建议依次尝试：1）刷新页面；2）切换播放线路（播放器右下角）；3）清除浏览器缓存；4）更换网络环境。如问题持续，可通过客服邮箱 support@nightcat.tv 联系我们，我们会在工作时间内尽快响应。',
  },
];

export default function SectionFAQ() {
  return (
    <section id="faq" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-3xl mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-3">
          常见问题
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">关于夜猫影院，你可能想知道的一切</p>
        <div className="space-y-3">
          {faqs.map((item, idx) => (
            <details key={idx} className="group bg-background-100 rounded-xl border border-background-200/70 overflow-hidden">
              <summary className="flex items-center justify-between px-5 py-4 cursor-pointer list-none">
                <h3 className="font-heading text-sm md:text-base text-foreground-900 pr-4">{item.question}</h3>
                <span className="w-6 h-6 rounded-full bg-background-200 flex items-center justify-center shrink-0 group-open:bg-primary-100 group-open:text-primary-600 transition-colors">
                  <i className="ri-arrow-down-s-line text-sm group-open:rotate-180 transition-transform"></i>
                </span>
              </summary>
              <div className="px-5 pb-4">
                <p className="text-sm text-foreground-600 leading-relaxed">{item.answer}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}